import { DataBean } from "../DataBean";

export class FortnightTypeConstants extends DataBean {


    public async getFortnightTypeConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFortnightTypeConstants_Number", [id]);
    }
}